import { makeVar } from '@apollo/client';

const globalStore = makeVar({
  loading: false,
  error: false,
  refreshRoute: '/app/general/dashboard',
});

export default globalStore;
